export const findNearest = (elem: number, options: Array<number>): number => {
  if (options.length === 0) {
    return elem;
  }

  let nearestDistance = Math.abs(elem - options[0]);
  const nearestIndex = options.reduce((nearestIndex, option, index) => {
    const distance = Math.abs(elem - option);
    if (distance < nearestDistance) {
      nearestIndex = index;
      nearestDistance = distance;
    }
    return nearestIndex;
  }, 0);
  return options[nearestIndex];
};
